import { useState } from 'react'
import { PaginationInfo } from '../../NonReact/Types/Types'
import { AdminFilterValues } from '../Components/Molecules/AdminFilters/AdminFilters'
import { ReactState } from '../../React/Common/Types/Types'

export const DEFAULT_ROWS_PER_PAGE: number = 25

export type UseAdminStatState = {
    loading: number
    setLoading: (loading: (currentLoading: number) => number) => void
    sort: Definable<string>
    setSort: (sort: Definable<string>) => void
    filters: Nullable<AdminFilterValues>
    setFilters: (filters: Nullable<AdminFilterValues>) => void
    pagination: PaginationInfo
    setPagination: (pagination: PaginationInfo) => void
    totalCount: number
    setTotalCount: (totalCount: number) => void
}

export function useAdminTableState(initialRowsPerPage = DEFAULT_ROWS_PER_PAGE) {
    const [loading, setLoading] = useState<number>(0)

    const [sort, setSort]: ReactState<Definable<string>> = useState<Definable<string>>()

    const [filters, setFilters]: ReactState<Nullable<AdminFilterValues>> = useState<Nullable<AdminFilterValues>>(null)

    const [pagination, setPagination]: ReactState<PaginationInfo> = useState<PaginationInfo>([0, initialRowsPerPage])

    const [totalCount, setTotalCount]: ReactState<number> = useState<number>(0)

    return {
        loading,
        setLoading,
        sort,
        setSort,
        filters,
        setFilters,
        pagination,
        setPagination,
        totalCount,
        setTotalCount
    }
}
